import { BulkDepositRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateBulkDeposit = makeValidator({
  FieldParser: BulkDepositRow,
});
